import { createVuetify } from 'vuetify'
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import * as labsComponents from 'vuetify/labs/components'
import 'vuetify/lib/styles/main.sass'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import colors from 'vuetify/lib/util/colors'

const vuetify = new createVuetify({
    components: {
        ...components,
        ...labsComponents
    },
    directives,
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        dark: true,
        themes: {
            light: {
                dark:false,
                colors: {
                    primary: '#3C7CC9'}
            },
            dark: {
                light:false,
                colors: {
                    primary: '#9c2450'}
            },
        },
    }
});

export default vuetify;